<div
  class="appointment-container rating"
  *ngIf="!editMode && !showRemoveAppointmentBtn && showRating"
>
  <app-label [text]="'Please rate us & help us serve you better!'"> </app-label>
  <div class="rating-container">
    <ng-container *ngFor="let rating of ratings; let index = index">
      <span
        (click)="selectRating(index)"
        [ngClass]="rating.selected ? 'selected-rating' : ''"
        >{{ rating.text }}</span
      >
    </ng-container>
  </div>
</div>
<div *ngIf="!editMode">
  <app-expansion-panel [title]="'Appointment Details:'" [expanded]="true">
    <app-appointment-tracking></app-appointment-tracking>
    <div class="filter-items-container">
      <app-label
        ngProjectAs="name"
        *ngIf="!editMode"
        [text]="'Appointment Date'"
      >
      </app-label>
      <app-form-row-split>
        <app-form-row>
          <app-label *ngIf="!editMode" [text]="item.date"> </app-label>
          <br />
        </app-form-row>
        <app-form-row>
          <app-label
            ngProjectAs="name"
            *ngIf="!editMode"
            [text]="'Appointment Time Slot'"
          >
          </app-label>
          <app-label *ngIf="!editMode" [text]="item.time"> </app-label>
        </app-form-row>
      </app-form-row-split>
      <app-button
        [button]="removeAppointmentButton"
        *ngIf="showRemoveAppointmentBtn"
      >
      </app-button>
    </div>
  </app-expansion-panel>
</div>
<div *ngIf="item" class="appointment-container">
  <div class="profile-photo">
    <img
      class="profile-pic"
      *ngIf="item?.userId?.picture"
      loading="lazy"
      [src]="
        environment.baseURL +
          'user/profile/picture/cdn/' +
          (item!.userId!.picture || '') | safeImage
      "
      alt=""
    />
    <div
      *ngIf="!item!.userId?.picture"
      [ngClass]="'profile-pic no-img'"
      [style.background-image]="'url(' + icon + ')'"
    ></div>
    <div
      class="status"
      *ngIf="item.clinic && item.clinic.length > 0"
      [matTooltip]="
        item!.clinic[0]!.online === online
          ? ('online' | transloco)
          : ('offline' | transloco)
      "
      [matTooltipPosition]="'above'"
      [ngClass]="
        item!.clinic[0]!.online === online ? 'status-online' : 'status-offline'
      "
    ></div>
    <div class="profile">
      <div>
        <span
          >Dr. {{ item!.userId?.firstName }} {{ item!.userId?.lastName }}</span
        >
      </div>
      <div class="qualification">
        <ng-container
          *ngFor="let degree of item.qualification && item.qualification.degree"
        >
          <span class="title">{{ MedicalDegree[degree] }}</span>
        </ng-container>
        <ng-container
          *ngIf="
            item!.qualification! &&
            item!.qualification!.practicingSince &&
            getCalculatedExperience(item!.qualification!.practicingSince) > 0
          "
        >
          <span class="title"
            >, ({{
              getCalculatedExperience(item!.qualification!.practicingSince)
            }}
            Year(s) of Experience)</span
          >
        </ng-container>
      </div>
      <div class="qualification">
        <ng-container
          *ngFor="
            let area of item.qualification && item.qualification.areaOfPractice
          "
        >
          <span class="title">{{ AreaOfPractice[area] }},</span>
        </ng-container>
      </div>
      <div class="clinic-container" *ngIf="item!.clinic && item!.clinic[0]">
        {{ item!.clinic[0]!.name }}
      </div>
    </div>
  </div>

  <div class="detail-container">
    <app-form-row-split>
      <app-form-row>
        <app-label ngProjectAs="name" [text]="'Case Paper Fee'"> </app-label>
        <span class="title">{{
          item.clinic && item.clinic[0] && item.clinic[0]!.fees
        }}</span>
      </app-form-row>
      <app-form-row>
        <app-label ngProjectAs="name" [text]="'Contact'"> </app-label>
        <div class="contact-container">
          <ng-container
            *ngFor="
              let contact of item.clinic &&
                item.clinic[0] &&
                item.clinic[0]!.helpline
            "
          >
            <span class="title word-break">{{ contact }},</span>
          </ng-container>
        </div>
      </app-form-row>
      <app-form-row>
        <app-label ngProjectAs="name" [text]="'Address'"> </app-label>
        <span
          class="title"
          *ngIf="
            item.clinic &&
            item.clinic!.length > 0 &&
            item.clinic[0]!.location &&
            item.clinic[0]!.location.block
          "
          >{{ item.clinic[0]!.location.block }},</span
        >
        <span
          class="title"
          *ngIf="
            item.clinic &&
            item.clinic!.length > 0 &&
            item.clinic[0]!.location &&
            item.clinic[0]!.location.city
          "
          >{{ item.clinic[0]!.location.city }},</span
        >
        <span
          class="title"
          *ngIf="
            item.clinic && item.clinic!.length > 0 && item.clinic[0]!.location
          "
          >{{ City[item.clinic[0]!.location.subDistrict] }},</span
        >
        <span
          class="title"
          *ngIf="
            item.clinic && item.clinic!.length > 0 && item.clinic[0]!.location
          "
          >{{ State[item.clinic[0]!.location.state] }},</span
        >
        <span
          class="title"
          *ngIf="
            item.clinic && item.clinic!.length > 0 && item.clinic[0]!.location
          "
          >Pin - {{ item.clinic[0]!.location.zip }}
        </span>
        <a
          *ngIf="
            item.clinic && item.clinic!.length > 0 && item.clinic[0]!.location
          "
          [href]="item.clinic[0]!.location.mapURL"
          target="_blank"
        >
          <app-icon [item]="mapIcon"> </app-icon>
        </a>
      </app-form-row>
    </app-form-row-split>
    <app-form-row-split>
      <app-form-row
        *ngIf="
          item.clinic &&
          item.clinic[0] &&
          item.clinic[0]!.appointment &&
          item.clinic[0]!.appointment!.holiday &&
          item.clinic[0]!.appointment!.holiday!.length > 0
        "
      >
        <app-label ngProjectAs="name" [text]="'Holidays'"> </app-label>
        <div class="contact-container">
          <ng-container
            *ngFor="
              let holiday of item.clinic &&
                item.clinic[0] &&
                item.clinic[0]!.appointment!.holiday
            "
          >
            <span class="title word-break holiday">{{
              holiday | date: "dd MMM yyyy"
            }}</span>
          </ng-container>
        </div>
      </app-form-row>
    </app-form-row-split>
    <div
      *ngIf="
        item.clinic &&
        item.clinic[0] &&
        item.clinic[0]!.appointment &&
        item.clinic[0]!.appointment!.workDays &&
        item.clinic[0]!.appointment!.workDays!.length > 0
      "
    >
      <app-label ngProjectAs="name" [text]="'Working Days & Timing'">
      </app-label>
      <div class="workday-container-parent">
        <ng-container
          *ngFor="
            let workday of item.clinic &&
              item.clinic[0] &&
              item.clinic[0]!.appointment!.workDays
          "
        >
          <div class="workday-container" *ngIf="workday.time.length > 0">
            <div class="header">
              <app-label [text]="DaysOfWeek[workday.day]"></app-label>
            </div>
            <ng-container *ngFor="let time of workday.time">
              <div class="body">
                <span>From</span> {{ TimeSlot[time.from] }} <span>To</span>
                {{ TimeSlot[time.to] }}
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <app-form-row-split>
      <app-form-row>
        <app-label
          ngProjectAs="name"
          *ngIf="editMode"
          [text]="'Choose appointment date'"
        >
        </app-label>
        <div class="title">
          <app-basic-calender
            *ngIf="editMode"
            class="title"
            [calender]="calender"
            [control]="dateControl"
            (selected)="onDateChanege($event)"
          >
          </app-basic-calender>
        </div>
      </app-form-row>
      <app-form-row *ngIf="showTimeControl">
        <app-label
          ngProjectAs="name"
          *ngIf="editMode"
          [text]="'Choose Time Slot'"
        >
        </app-label>
        <div class="title">
          <app-select-box
            *ngIf="editMode"
            class="title"
            [control]="timeControl"
            [itemList]="timeSlot"
          >
          </app-select-box>
        </div>
      </app-form-row>
    </app-form-row-split>
  </div>
  <app-button [button]="bookAppointmentButton" *ngIf="editMode"> </app-button>
</div>

<ng-template #errorMsg>
  <app-label [text]="'Appointment is already exist for given date'">
  </app-label>
</ng-template>

<ng-template #appointmentFullErrorMsg>
  <app-label
    [text]="
      'Appointments are full for selected time slot, please select different time slot'
    "
  >
  </app-label>
</ng-template>

<ng-template #holidayErrorMsg>
  <app-label [text]="'Selected date is holiday, please choose another date'">
  </app-label>
</ng-template>

<ng-template #workingDayErrorMsg>
  <app-label
    [text]="'Selected date is not working day, please choose another date'"
  >
  </app-label>
</ng-template>

<ng-template #successMsgHeader>
  <div class="dialog-header">
    <span mat-dialog-title>Success</span>
  </div>
</ng-template>

<ng-template #successMsg>
  <app-label [text]="'Appointment created successfully!'"> </app-label>
</ng-template>

<ng-template #ratingSuccessMsg>
  <app-label [text]="'Ratings saved successfully!'"> </app-label>
</ng-template>

<ng-template #removeAppointmentMsg>
  <app-label [text]="'Appointment removed successfully!'"> </app-label>
</ng-template>

<ng-template #removeAppointmentErrorMsg>
  <app-label [text]="'Error while removing the appointment. Please try again.'">
  </app-label>
</ng-template>

<ng-template #saveRatingErrorMsg>
  <app-label [text]="'Error while saving the ratings. Please try again.'">
  </app-label>
</ng-template>

<ng-template #footerMsg>
  <app-button [button]="okeyButton"> </app-button>
</ng-template>

<ng-template #ratingFooterMsg>
  <app-button [button]="ratingOkeyButton"> </app-button>
</ng-template>
